import BookIcon from '@material-ui/icons/Book'
import StocksByGoodsList from './StocksByGoodsList'

export default {
    list: StocksByGoodsList,
    icon: BookIcon,
}
